// 公共常量

// 当前项目的理由 BASE URL
export const ROUTER_BASE_URL = '/conference/2025-1/index/main';

// 当前生效的会议 code
export const ENABLED_CONFERENCE_CODE = '2025-first';

// 报名
export const REGISTRATION_URL_DESKTOP = 'https://openatomcon.openatom.cn/registration/?activityNo=HD20250703111116';
export const REGISTRATION_URL_MOBILE = 'https://openatomcon.openatom.cn/registration_mobile/?activityNo=HD20250703111116';
